export default __webpack_public_path__ + "static/media/email-otp.bacd8ce8.svg";